/*************************************************************************
 *  ADOBE CONFIDENTIAL
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/

import * as React from 'react';
import './index.scss';

/**
 * Horizontal separator
 */

const HorizontalRuler: React.FunctionComponent = (): JSX.Element => (
	<hr className='horizontal-divider' role='presentation' aria-hidden='true' />
);

export default HorizontalRuler;
